import React from 'react'
import '../../styles/Achievements.css'
import FooterFrame from '../../svg/achievements/FooterFrame.svg'
import FooterFrontFrame from '../../svg/achievements/FooterFrontFrame.svg'
import AchievementsHeader from './AchievementsHeader'
import OurAchievements from './OurAchievements'
import OurRewards from './OurRewards'
import { useTranslation } from 'react-i18next'

function Achievements() {
    const { t } = useTranslation()

    return (
        <div className="achievements-container">
            <div className="achievements-center-container" style={{ zIndex: 1 }}>
                <AchievementsHeader />
                <div className="achievements-center-body">
                    <OurAchievements />
                    <OurRewards />
                </div>
            </div>
            <div className="achievements-footer-image" style={{ zIndex: 0, backgroundImage: `url(${FooterFrame})` }}></div>
            <div className="achievements-front-footer-image" style={{ zIndex: 2, backgroundImage: `url(${FooterFrontFrame})` }}>
                <div className="achievements-footer-buttons">
                    <button className="achievements-footer-button-transfer">{t('Transfer earned points to Dummo')}</button>
                    <button className="achievements-footer-button-exchange">{t('Exchange for a reward')}</button>
                </div>
            </div>
        </div>
    )
}

export default Achievements
